import React from 'react';
import { Polygon } from '@react-google-maps/api';
import { getZoneOptions } from 'helpers/utils';

const ViewSelectedRowsForVersionHistoryTable = (props) => {
  const { selectedRowsForVersionHistoryTable } = props;

  return selectedRowsForVersionHistoryTable?.map((selectedRow, index) => (
    <Polygon
      key={index}
      paths={selectedRow?.zonePolygonJson}
      options={getZoneOptions({
        strokeWeight: 4,
        fillColor: selectedRow.color ?? 'black',
        strokeColor: 'red',
        editable: false,
        fillOpacity: selectedRow.tranparency ?? 1,
        zIndex: 1000,
      })}
    />
  ));
};

export default ViewSelectedRowsForVersionHistoryTable;
